import { render, staticRenderFns } from "./ApprovalGeneralKasbon.vue?vue&type=template&id=74021e46"
import script from "./ApprovalGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./ApprovalGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports